import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
  FETCH_REASONS,
  RECEIVED_REASONS,
} from './constants';

export function fetchReasonsAction() {
  return {
    type: FETCH_REASONS,
    fetchCall: fetchReasons,
    receivedAction: receivedReasons,
    data: {
      locations,
    },
  };
}

export function fetchReasons() {
  return CFAuthGetRef({
    url: process.env.REACT_APP_COACHING_API_URL + '/api/Mappings/Reasons',
    params: null,
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchCoachingReasons'
  });
}

export function receivedReasons(data) {
  return {
    type: RECEIVED_REASONS,
    data,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_REASONS:
      return {
        ...state,
        reasons: action.data,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchReasons.js